module.exports = __webpack_public_path__ + "media/images/countrysquared/ht-99fe90ecf4aa9f7143f886273335e6d2.svg";